"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const _1 = require(".");
function default_1({ open, closeDialog, userId, onCompanyInfoDeleteSuccess, }) {
    const pendingRef = (0, react_1.useRef)(false);
    const safeCloseDialog = () => {
        !pendingRef.current && closeDialog();
    };
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog: safeCloseDialog, dialogName: 'company-delete' });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, onClose: safeCloseDialog, slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-80)' } } }, PaperProps: {
            sx: {
                width: '374px',
                padding: '14px',
                borderRadius: '16px',
                margin: '0 20px',
            },
        } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '16px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "body1 gray-60", css: {
                        '> div': {
                            display: 'flex',
                            '&::before': { content: '" • "', margin: '-1px 8px 0px 6px', fontWeight: 'bold' },
                        },
                    } }, { children: [t('사업자 정보 폐기하면'), (0, jsx_runtime_1.jsx)("div", { children: t('연결된 프로필의 사업자 정보 게시 취소 돼요') }), (0, jsx_runtime_1.jsx)("div", { children: t('폐기 전 접수된 세금계산서는 그대로 발행 돼요') })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: safeCloseDialog, sx: {
                                width: '100%',
                                height: '40px',
                                padding: '0 16px',
                                borderRadius: '8px',
                                border: '1px solid var(--gray-10)',
                                color: 'var(--gray-80)',
                                bgcolor: 'var(--white) !important',
                            } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body3" }, { children: t('취소') })) })), (0, jsx_runtime_1.jsx)(_1.DeleteCompany, { pendingRef: pendingRef, closeDialog: closeDialog, userId: userId, onCompanyInfoDeleteSuccess: onCompanyInfoDeleteSuccess })] }))] })) })));
}
exports.default = default_1;
